import React from 'react';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { ProductId } from 'services/products/types';
import { createStructuredSelector } from 'reselect';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { UnitTypeName } from 'services/unitTypes/types';
import { SprayUnitsPerHundredLitre } from 'services/sprayEvents/types';
import {
    makeSelectProductRatePerHundredLitre,
    makeSelectProductUnitType
} from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: ProductId;
}

interface ConnectedProps {
    productRatePerHundredLitre: SprayUnitsPerHundredLitre;
    productUnitType: UnitTypeName;
}

type Props = OwnProps & ConnectedProps;

export class ProductRatePerHundredLitreTableCellComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { productRatePerHundredLitre, productUnitType } = this.props;

        return (
            <TableCell>
                {productRatePerHundredLitre}
                {productUnitType}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    productRatePerHundredLitre: makeSelectProductRatePerHundredLitre(),
    productUnitType: makeSelectProductUnitType()
});

export default connect(mapStateToProps)(
    ProductRatePerHundredLitreTableCellComponent
);
